import {
    Box,
    Button,
    Container,
    Paper,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

const rows = [
    {
        name: "IBEX35_SPOT",
        img: "Images/EE1.png",
        sub: "Australia200",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "GER30_SPOT",
        img: "Images/EE2.png",
        sub: "Germany30",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "UK100_SPOT",
        img: "Images/EE3.png",
        sub: "United Kingdom100",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "EUR50_SPOT",
        img: "Images/EE4.png",
        sub: "Europe50",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "NO25_SPOT",
        img: "Images/EE5.png",
        sub: "Norway25",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "CH20_SPOT",
        img: "Images/EE6.png",
        sub: "Switzerland20",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "NL25_SPOT",
        img: "Images/EE7.png",
        sub: "Netherland25",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "CAC40_SPOT",
        img: "Images/EE8.png",
        sub: "Euronext Paris40",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "IT40_SPOT",
        img: "Images/EE9.png",
        sub: "Italy40",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
];
const rows1 = [
    {
        name: "US30",
        img: "Images/US30.png",
        sub: "S&P 500 (US500)",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "US100",
        img: "Images/US100.png",
        sub: "S&P 500 (US500)",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "US30",
        img: "Images/US30.png",
        sub: "S&P 500 (US500)",
        spread: "2.5",
        leverage: "1,000",
        lowSpread: "2.0",
    },
    {
        name: "US100", sub: "Bitcoin vs U.S. Dollar", spread: "1.2", leverage: "1,000",
        lowSpread: "35:65",
        img: "Images/US100.png",
    },
    {
        name: "US30", img: "Images/US30.png", sub: "Bitcoin vs U.S. Dollar", spread: "1.4", leverage: "1,000",
        lowSpread: "35:65"
    },
    {
        name: "US100", img: "Images/US100.png", sub: "Bitcoin vs U.S. Dollar", spread: "1.1", leverage: "1,000",
        lowSpread: "35:65"
    },
    {
        name: "US30", img: "Images/US30.png", sub: "Bitcoin vs U.S. Dollar", spread: "1.4", leverage: "1,000",
        lowSpread: "35:65"
    },
    {
        name: "US100", img: "Images/US100.png", sub: "Bitcoin vs U.S. Dollar", spread: "1.1", leverage: "1,000",
        lowSpread: "35:65"
    },
    {
        name: "US30", img: "Images/US30.png", sub: "Bitcoin vs U.S. Dollar", spread: "1.4", leverage: "1,000",
        lowSpread: "35:65"
    },
    {
        name: "US100", img: "Images/US100.png", sub: "Bitcoin vs U.S. Dollar", spread: "1.1", leverage: "1,000",
        lowSpread: "35:65"
    },
];
export const PairIndic = ({ title, subtitle, type }) => {
    const [value, setValue] = useState(0);
    const { language, translations } = useLanguage();

    console.log("Sdgasdgasd", value);
    const handleChange = (_, newValue) => {
        setValue(newValue);
    };
    return (
        <Box
            sx={{
                // height: "100vh",
                backgroundColor: "#f3f9ff",
                padding: "5rem 24px",
            }}
        >
            <Container maxWidth="xl">
                <Box textAlign="center" mb={5}>
                    <Typography variant="h2">{title ?? ""}</Typography>
                    <Typography
                        sx={{
                            fontSize: "22px",
                            color: "rgba(102, 112, 133, 1)",
                            fontWeight: "400",
                            fontFamily: "SF Pro Display",
                            mt: 2,
                        }}
                    >
                        {subtitle ?? ""}
                    </Typography>
                    <Box
                        sx={{
                            bgcolor: "#fff",
                            p: "3px",
                            borderRadius: "16.93px",
                            display: "inline-block",
                            mt: 3.5,
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            sx={{
                                fontFamily: "SF Pro Display",
                                minHeight: "unset",
                                "& .MuiTab-root": {
                                    textTransform: "none",
                                    fontWeight: "500",
                                    minHeight: "unset",
                                    minWidth: 0,
                                    px: 3,
                                    py: 1.5,
                                    borderRadius: "16.93px",
                                    fontSize: "16px",
                                },
                                "& .Mui-selected": {
                                    bgcolor: "#E0F1F9",
                                    color: "#2494C9",
                                },
                                "& .MuiTab-root:not(.Mui-selected)": {
                                    color: "#6c757d",
                                },
                            }}
                        >
                            <Tab disableRipple label={"Cash Indices"} />
                            <Tab disableRipple label={"Future Indices"} />
                        </Tabs>
                    </Box>
                </Box>
                {value === 0 ? (
                    <Box sx={{ padding: { xs: "10px", md: "10px 2.5rem" } }}>
                        <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                                borderRadius: 3,
                                p: 2,
                                border: "1px solid rgba(102, 112, 133, 0.22)",
                            }}
                        >
                            <Table
                                sx={{
                                    borderSpacing: "0 12px",
                                    borderCollapse: "separate",
                                    "& tbody td": {
                                        border: "none",
                                    },
                                }}
                            >
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#fff" }}>
                                        {[
                                            translations[language]?.tableData?.Symbol,
                                            translations[language]?.tableData?.AverageSpread,
                                            // translations[language]?.tableData?.Spread,
                                            translations[language]?.tableData?.MaxLeverage,
                                            translations[language]?.tableData?.Action,
                                        ]?.map((text, idx) => (
                                            <TableCell
                                                key={idx}
                                                align={idx === 0 ? "left" : "center"}
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: 18,
                                                    color: text === "Action" ? "#fff" : "#667085",
                                                    borderBottom: "1px solid rgba(197, 208, 225, 0.66)",
                                                    textWrap: "nowrap",
                                                    //  paddingLeft:'65px'
                                                }}
                                            >
                                                {text}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {rows.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                backgroundColor: i % 2 === 0 ? "#F7F7F7" : "#ffffff",
                                            }}
                                        >
                                            {[
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <img
                                                        src={row?.img ?? "Images/flagsd.png"}
                                                        style={{ width: "46px" }}
                                                    />
                                                    <Box>
                                                        <Typography
                                                            variant="h5"
                                                            sx={{
                                                                textAlign: "start",
                                                                pl: 2,
                                                                fontWeight: "600",
                                                            }}
                                                        >
                                                            {row?.name}
                                                        </Typography>
                                                        <Typography
                                                            variant="h5"
                                                            sx={{
                                                                textAlign: "start",
                                                                pl: 2,
                                                                textWrap: "nowrap",
                                                                fontWeight: '400',
                                                                color: 'rgba(102, 112, 133, 1)'
                                                            }}
                                                        >
                                                            {row?.sub}
                                                        </Typography>
                                                    </Box>
                                                </Box>,
                                                row.spread,
                                                // row.lowSpread,
                                                row.leverage,
                                                <Button
                                                    disableRipple
                                                    component="a"
                                                    href="https://portal.bbcorp.trade/auth/jwt/sign-up/" // ← your actual link here
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    sx={{
                                                        background: "#E0F1F9",
                                                        borderRadius: "10px",
                                                        px: 3,
                                                        py: 1,
                                                        color: "#2494C9",
                                                        textTransform: "capitalize",
                                                        fontWeight: "500",
                                                        marginRight: {
                                                            xs: "0px !important",
                                                            md: "-2.5rem !important",
                                                        },
                                                        "&:hover": {
                                                            color: "#2494C9",
                                                            background: "#E0F1F9",
                                                        },
                                                    }}
                                                >
                                                    Trade
                                                </Button>,
                                            ].map((content, cellIndex, arr) => (
                                                <TableCell
                                                    key={cellIndex}
                                                    align={cellIndex === 0 ? "left" : "center"}
                                                    sx={{
                                                        ...(cellIndex === 0 && {
                                                            borderTopLeftRadius: "20px",
                                                            borderBottomLeftRadius: "20px",
                                                        }),
                                                        ...(cellIndex === arr.length - 1 && {
                                                            borderTopRightRadius: "20px",
                                                            borderBottomRightRadius: "20px",
                                                        }),
                                                        overflow: "hidden",
                                                        borderBottom: "none", // optional
                                                    }}
                                                >
                                                    {content}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                ) : (
                    <Box sx={{ padding: { xs: "10px", md: "10px 2.5rem" } }}>
                        <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                                borderRadius: 3,
                                p: 2,
                                border: "1px solid rgba(102, 112, 133, 0.22)",
                            }}
                        >
                            <Table
                                sx={{
                                    borderSpacing: "0 12px",
                                    borderCollapse: "separate",
                                    "& tbody td": {
                                        border: "none",
                                    },
                                }}
                            >
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#fff" }}>
                                        {[
                                            translations[language]?.tableData?.Symbol,
                                            translations[language]?.tableData?.AverageSpread,
                                            // translations[language]?.tableData?.Spread,
                                            translations[language]?.tableData?.MaxLeverage,
                                            translations[language]?.tableData?.Action,
                                        ]?.map((text, idx) => (
                                            <TableCell
                                                key={idx}
                                                align={idx === 0 ? "left" : "center"}
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: 18,
                                                    color: text === "Action" ? "#fff" : "#667085",
                                                    borderBottom: "1px solid rgba(197, 208, 225, 0.66)",
                                                    textWrap: "nowrap",
                                                    //  paddingLeft:'65px'
                                                }}
                                            >
                                                {text}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {rows1.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                backgroundColor: i % 2 === 0 ? "#F7F7F7" : "#ffffff",
                                            }}
                                        >
                                            {[
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <img
                                                        src={row?.img ?? "Images/flagsd.png"}
                                                        style={{ width: "46px" }}
                                                    />
                                                    <Box>
                                                        <Typography
                                                            variant="h5"
                                                            sx={{
                                                                textAlign: "start",
                                                                pl: 2,
                                                                fontWeight: "600",
                                                            }}
                                                        >
                                                            {row?.name}
                                                        </Typography>
                                                        <Typography
                                                            variant="h5"
                                                            sx={{
                                                                textAlign: "start",
                                                                pl: 2,
                                                                textWrap: "nowrap",
                                                                fontWeight: '400',
                                                                color: 'rgba(102, 112, 133, 1)'
                                                            }}
                                                        >
                                                            {row?.sub}
                                                        </Typography>
                                                    </Box>
                                                </Box>,
                                                row.spread,
                                                // row.lowSpread,
                                                row.leverage,
                                                <Button
                                                    disableRipple
                                                    component="a"
                                                    href="https://portal.bbcorp.trade/auth/jwt/sign-up/" // ← your actual link here
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    sx={{
                                                        background: "#E0F1F9",
                                                        borderRadius: "10px",
                                                        px: 3,
                                                        py: 1,
                                                        color: "#2494C9",
                                                        textTransform: "capitalize",
                                                        fontWeight: "500",
                                                        marginRight: {
                                                            xs: "0px !important",
                                                            md: "-2.5rem !important",
                                                        },
                                                        "&:hover": {
                                                            color: "#2494C9",
                                                            background: "#E0F1F9",
                                                        },
                                                    }}
                                                >
                                                    Trade
                                                </Button>,
                                            ].map((content, cellIndex, arr) => (
                                                <TableCell
                                                    key={cellIndex}
                                                    align={cellIndex === 0 ? "left" : "center"}
                                                    sx={{
                                                        ...(cellIndex === 0 && {
                                                            borderTopLeftRadius: "20px",
                                                            borderBottomLeftRadius: "20px",
                                                        }),
                                                        ...(cellIndex === arr.length - 1 && {
                                                            borderTopRightRadius: "20px",
                                                            borderBottomRightRadius: "20px",
                                                        }),
                                                        overflow: "hidden",
                                                        borderBottom: "none", // optional
                                                    }}
                                                >
                                                    {content}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
                <Box textAlign="center" mt={5}>
                    <Typography
                        sx={{
                            fontSize: "22px",
                            color: "rgba(102, 112, 133, 1)",
                            fontWeight: "400",
                            fontFamily: "SF Pro Display",
                            mt: 2,
                        }}
                    >
                        {translations[language]?.bttomTxt}
                    </Typography>
                    <Button
                        component="a"
                        href="https://portal.bbcorp.trade/auth/jwt/sign-up/" // ← your actual link here
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            background: "rgba(224, 241, 249, 1)",
                            borderRadius: "10px",
                            padding: "8px 24px",
                            color: "rgba(36, 148, 201, 1)",
                            // textTransform: "capitalize",
                            marginTop: "35px",
                            fontWeight: "500",
                            "&:hover": {
                                color: "rgba(36, 148, 201, 1)",
                            },
                        }}
                    >
                        {translations[language]?.RegisBTN}
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};
